import React from 'react';

/** EDB header brand mark — violet tile with circuit-style E (matches EDB v2 chrome). */
export function EdbBrandMark(): React.ReactElement {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className="global-header-edb-mark"
    >
      <defs>
        <linearGradient id="edb-header-brand-grad" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
          <stop stopColor="var(--gaxl-violet-500)" />
          <stop offset="1" stopColor="var(--gaxl-indigo-500)" />
        </linearGradient>
      </defs>
      <rect width="24" height="24" rx="6" fill="url(#edb-header-brand-grad)" />
      <path
        d="M7.5 7.5h8.5M7.5 12h8.5M7.5 16.5h8.5M7.5 7.5v9"
        stroke="var(--gaxl-neutral-0)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="7.5" cy="7.5" r="1.25" fill="var(--gaxl-neutral-0)" />
      <circle cx="7.5" cy="12" r="1.25" fill="var(--gaxl-neutral-0)" />
      <circle cx="7.5" cy="16.5" r="1.25" fill="var(--gaxl-neutral-0)" />
      <circle cx="16" cy="7.5" r="1.25" fill="var(--gaxl-neutral-0)" />
      <circle cx="16" cy="12" r="1.25" fill="var(--gaxl-neutral-0)" />
      <circle cx="16" cy="16.5" r="1.25" fill="var(--gaxl-neutral-0)" />
    </svg>
  );
}
